import { applyMiddleware, compose, createStore } from "redux";
import rootReducer from "../reducers";

//Middleware
//Logger
import logger from "redux-logger";

//Router
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

//Sagas
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/rootSaga";

//Thunk
import thunk from "redux-thunk";

//Create Logger
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//Create Middleware
export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

//Create Store
const store =
  process.env.NODE_ENV === "production"
    ? createStore(
        connectRouter(history)(rootReducer),
        applyMiddleware(routerMiddleware(history), sagaMiddleware, thunk)
      )
    : createStore(
        connectRouter(history)(rootReducer),
        composeEnhancers(applyMiddleware(routerMiddleware(history), logger, sagaMiddleware, thunk))
      );

//Run sagas
sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js